
<Section class="dialogSection">
  <kendo-dialog
                title="{{quoteLblTxt.addQuoteTitleLbl?quoteLblTxt.addQuoteTitleLbl:quoteDialog.addQuoteTitleLbl}}" (close)="closeQuoteModal()">
    <!--<hr class="solid">-->
    <div class="container-fluid" [hidden]="showItemAddedSuccess">
      <form [formGroup]="addQuoteForm" autocomplete="off">
        <input type="hidden" formControlName="itemId" />
        <div class="form-row">
          <div class="form-group col-md-12">
            <h6>{{quoteLblTxt.addExistingQuoteLbl?quoteLblTxt.addExistingQuoteLbl:quoteDialog.addExistingQuoteLbl}}</h6>
            <label class="lblCls align-left">
              {{quoteLblTxt.quoteLbl?quoteLblTxt.quoteLbl:quoteDialog.quoteLbl}} <span class="requiredField">*</span>
            </label>
            <kendo-dropdownlist [data]="quoteData" formControlName="quote"
                                [ngModel]="{jobName:selectedJobName,quoteCommonId:selectedQuoteCommonId}"
                                textField="quoteDisplayName" valueField="quoteCommonId" kendoTextBox class="kendoInput" [filterable]="true" (filterChange)="handleQuoteFilter($event)"
                                [ngClass]="{'borderRed':quoteDialog.isEmptyQuote}" (selectionChange)="quoteDropdownChange($event)">
            </kendo-dropdownlist>
          </div>
        </div>
        <div class="dialog-btn-section">

          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button (click)="saveItemToQuote()" class="m-3 btn btn-success" kendoButton
                        [disabled]="addQuoteInProcess">
                  {{quoteLblTxt.addLbl?quoteLblTxt.addLbl:quoteDialog.addLbl}}<kendo-loader *ngIf="addQuoteInProcess" style="color:blue"></kendo-loader>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 float-left align-center">
              <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
            </div>
          </div>
        </div>
        <table width="100%">
          <tr>
            <td><hr /></td>
            <td style="width:1px; padding: 0 10px; white-space: nowrap;"><b>{{quoteLblTxt.orLbl?quoteLblTxt.orLbl:quoteDialog.orLbl}}</b></td>
            <td><hr /></td>
          </tr>
        </table>
        <div class="form-row">
          <div class="form-group col-md-12">
            <h6>{{quoteLblTxt.newQuoteLbl?quoteLblTxt.newQuoteLbl:quoteDialog.newQuoteLbl}}</h6>
            <label class="lblCls">
              {{quoteLblTxt.jobNameLbl?quoteLblTxt.jobNameLbl:quoteDialog.jobNameLbl}} <span class="requiredField">*</span>
            </label>
            <input type="text" kendoTextBox class="kendoInput" name="jobName" (blur)="validateAddQuoteForm()"
                   formControlName="jobName"
                   [ngClass]="{'borderRed':quoteDialog.isEmptyJobName && quoteDialog.isSubmitted}" [maxlength]="30" />
          </div>
          <div class="form-group col-md-12">
            <label class="lblCls">
              {{quoteLblTxt.marketSegmentLbl?quoteLblTxt.marketSegmentLbl:quoteDialog.marketSegmentLbl}} <span class="requiredField">*</span>
            </label>
            <kendo-dropdownlist [data]="marketSegments" formControlName="marketSegment"
                                (blur)="validateAddQuoteForm()" textField="name" valueField="value" class="kendoInput"
                                [ngClass]="{'borderRed':quoteDialog.isEmptyMarketSegment && quoteDialog.isSubmitted}">
            </kendo-dropdownlist>

          </div>
          <div class="form-group col-md-12">
            <label class="leedLbl lblCls">{{quoteLblTxt.leedLbl?quoteLblTxt.leedLbl:quoteDialog.leedLbl}} </label>
            <kendo-switch formControlName="leed" [onLabel]="'Yes'" [offLabel]="'No'" class="leedSwitchCls">
            </kendo-switch>
          </div>

        </div>
        <div class="dialog-btn-section">

          <div class="row">
            <div class="col-sm-12 btn-align-center">
              <div class="btn-group" role="group">
                <button style="width:150px;"
                        (click)="createAndSaveItemToQuote()"
                        class="m-3 btn btn-success dialogBtnSize" kendoButton
                        [disabled]="saveInProcess">
                  {{quoteLblTxt.createLbl?quoteLblTxt.createLbl:quoteDialog.createLbl}}<kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                </button>
                <button (click)="closeQuoteModal()" class=" m-3 btn k-button dialogBtnSize" kendoButton>
                  {{quoteLblTxt.cancelLbl?quoteLblTxt.cancelLbl:quoteDialog.cancelLbl}}
                </button>

              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 float-left align-center">
              <app-info *ngIf="infoMessageNewQuote" [infoMessage]="infoMessageNewQuote"></app-info>
              <p *ngIf="createQuoteSuccess">
                {{quoteLblTxt.addQuoteTitleLbl?quoteLblTxt.gotoQuoteLbl:quoteDialog.gotoQuoteLbl}}:
                <a class="links"
                   (click)="goToQuoteDetail()">
                  {{item.quoteDisplayName}}
                </a>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div [hidden]="!showItemAddedSuccess">
      <app-info *ngIf="infoMessage" [infoMessage]="infoMessage"></app-info>
      <app-info *ngIf="infoMessageNewQuote" [infoMessage]="infoMessageNewQuote"></app-info>
      <p *ngIf="createQuoteSuccess">
        {{quoteLblTxt.addQuoteTitleLbl?quoteLblTxt.gotoQuoteLbl:quoteDialog.gotoQuoteLbl}}:
        <a class="links"
           (click)="goToQuoteDetail()">
          {{item.quoteDisplayName}}
        </a>
      </p>
    </div>
  </kendo-dialog>
</Section>
